import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const Soweto = () => {
  const { page } = useParams();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    // Scroll to the top of the page
    window.scrollTo(0, 0);

    // Set loaded to true after a short delay to allow animations to occur
    const timeout = setTimeout(() => {
      setLoaded(true);
    }, 500);

    return () => clearTimeout(timeout);
  }, [page]); // Re-run effect when page changes

  return (
    <div className="bg-gray-600">
      <h1 className="text-center text-4xl py-4 text-white font-location">
        Kahawa West(Soweto)
      </h1>
      <div className="mx-auto max-w-7xl px-4 py-2 sm:px-6 ">
      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-2 xl:grid-cols-5 gap-3">

        <img src="gallery/soweto/soweto30.jpg" alt="soweto" className={`w-full rounded-md object-cover  h-72 transform hover:scale-120 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        <img src="gallery/soweto/soweto31.jpg" alt="soweto" className={`w-full rounded-md object-cover  h-72 transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        <img src="gallery/soweto/soweto32.jpg" alt="soweto" className={`w-full rounded-md object-cover  h-72 transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        <img src="gallery/soweto/soweto50.jpg" alt="soweto" className={`w-full  rounded-md object-cover h-72 transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        <img src="gallery/soweto/soweto35.jpg" alt="soweto" className={`w-full rounded-md object-cover  h-72 transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        <img src="gallery/soweto/soweto36.jpg" alt="soweto" className={`w-full rounded-md object-cover  h-72 transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        <img src="gallery/soweto/soweto38.jpg" alt="soweto" className={`w-full rounded-md object-cover h-72 transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        <img src="gallery/soweto/soweto39.jpg" alt="soweto" className={`w-full rounded-md object-cover  h-72 transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        <img src="gallery/soweto/soweto41.jpg" alt="soweto" className={`w-full rounded-md object-cover h-72 transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        <img src="gallery/soweto/soweto42.jpg" alt="soweto" className={`w-full rounded-md object-cover h-72 transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        {/* <img src="gallery/soweto/soweto43.jpg" alt="soweto" className={`w-full rounded-md object-cover  h-72 transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} /> */}
        <img src="gallery/soweto/soweto45.jpg" alt="soweto" className={`w-full rounded-md object-cover h-72 transform hover:scale-90 transition-transform duration-500 pb-4 ${loaded ? 'fade-in loaded' : ''}`} />
        </div>
      </div>
 </div>
  );
}

export default Soweto;
